export default __webpack_public_path__ + "check.9d63b1a908b3cfa7b7133594e78b5e1a.svg";